import ComplaintFilter from './ComplaintFilter'

export default ComplaintFilter
